export const formatUserName = (email?: string) => {
  if (!email) {
    return "N/A";
  }
  // If not an email, return the value as is
  if (!email.includes("@")) {
    return email;
  }
  const namePart = email.split("@")[0];
  if (!namePart) {
    return "N/A";
  }
  const nameParts = namePart.split(".");
  console.log("nameParts", nameParts);
  if (nameParts.length >= 2) {
    const firstName =
      nameParts[0].charAt(0).toUpperCase() + nameParts[0].slice(1);
    const lastName =
      nameParts[1].charAt(0).toUpperCase() + nameParts[1].slice(1);
    return `${firstName} ${lastName}`;
  }
  return nameParts[0].charAt(0).toUpperCase() + nameParts[0].slice(1);
};
